import { Animated, StyleSheet, View } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';


// Reusable gradient overlay (left-to-right, fades to 0% at 100%)
export const GradientOverlay = ({ opacity = 0, borderRadius = 0, direction = 'horizontal' }) => (
    <Animated.View pointerEvents="none" style={[StyleSheet.absoluteFillObject, { opacity, borderRadius, overflow: 'hidden' }] }>
      <LinearGradient
        colors={['rgba(255,255,255,0.16)', 'rgba(153,153,153,0.0)']}
        start={direction === 'horizontal' ? { x: 0, y: 0.5 } : { x: 0.5, y: 0 }}
        end={direction === 'horizontal' ? { x: 1, y: 0.5 } : { x: 0.5, y: 1 }}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );
  
  // Glass background gradient (15% opacity overall), vertical
  export const GlassBackgroundGradient = ({ borderRadius = 0, opacity = 0 }) => (
    <Animated.View pointerEvents="none" style={[StyleSheet.absoluteFillObject, { opacity, borderRadius, overflow: 'hidden' }]}> 
      <LinearGradient
        colors={['rgba(0,0,0,0.15)', 'rgba(116,132,154,0.15)']}
        start={{ x: 0.5, y: 0 }}
        end={{ x: 0.5, y: 1 }}
        style={StyleSheet.absoluteFill}
      />
    </Animated.View>
  );